import React, { useState, useEffect } from 'react';
import { Button, Paper, Typography, FormControl, Box, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createStone, updateStone } from '../../redux/actions/stone/stoneAction';
import { toast } from 'react-toastify';

const StoneForm = ({ selectedStone, onReset }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
  });

  useEffect(() => {
    if (selectedStone) {
      setFormData(selectedStone);
    } else {
      setFormData({ name: '' });
    }
  }, [selectedStone]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedStone) {
        await dispatch(updateStone(selectedStone.id, formData));
        toast.success('Stone updated successfully');
      } else {
        await dispatch(createStone(formData));
        toast.success('Stone created successfully');
      }
      setFormData({ name: '' });
      if (onReset) onReset();
    } catch (error) {
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while processing stone';
      toast.error(errorMessage);
    }
  };

  const handleClear = () => {
    setFormData({ name: '' });
    if (onReset) onReset();
  };

  return (
    <Paper elevation={3} sx={{ p: 3, boxShadow: 'none', background: 'transparent'  }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold' }} gutterBottom>
        {selectedStone ? 'Edit Stone Type' : 'Add Stone Type'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal" required>
          <TextField
            label="Stone Type"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter stone type"
            variant="outlined"
            required
            fullWidth
            size="medium"
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {selectedStone ? 'Update' : 'Add'}
          </Button>
          <Button 
            type="button" 
            variant="outlined" 
            color="primary" 
            fullWidth
            onClick={handleClear}
          >
            Clear
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default StoneForm;
